import { persistor, store } from "./state/store";

import FabGroup from "./layout/components/Buttons/FabGroup";
import GlobalStyle from "./layout/components/Setup/GlobalStyle";
import Header from "./layout/components/Header";
import Modals from "./layout/components/Modals";
import { PersistGate } from "redux-persist/es/integration/react";
import { Provider } from "react-redux";
import React from "react";
import Routes from "./routes";
import Setup from "./layout/components/Setup";
import { ThemeProvider } from "styled-components";
import theme from "./constants/ThemeConstants";

const Main: React.FC = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ThemeProvider theme={theme}>
                    <>
                        <GlobalStyle />
                        <Modals />
                        <Routes>
                            <Setup />
                            <Header />
                            <FabGroup />
                        </Routes>
                    </>
                </ThemeProvider>
            </PersistGate>
        </Provider>
    );
};

export default Main;
